import { createFileRoute } from '@tanstack/react-router';

import { ComplianceEventosPage } from '@/features/compliance/components/compliance-eventos-page';
import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';
import { useSelectedComplianceTenant } from '@/features/compliance/compliance-tenant-context';

export const Route = createFileRoute('/_app/compliance/eventos')({
  component: ComplianceEventosRoute,
});

function ComplianceEventosRoute() {
  const { selectedTenant } = useSelectedComplianceTenant();
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <ComplianceEventosPage tenantSlug={selectedTenant?.tenantSlug ?? ''} />
    </div>
  );
}
